import React, {Component} from "react";
import { findDOMNode } from 'react-dom';

import $ from 'jquery';
import Konva from 'konva';
import dragscroll from '../../Components/dragscroll'
import WebECG from '../../components/ecg-web';

import {
  Row,
  Col,
  Button,
  ButtonGroup,
  Label,
  Input,
  Table
} from "reactstrap";


class Ecg extends Component {

    constructor(props) {
        super(props);

        this.state= {
            instanciated: false,
            ecgData: null
        };
    }

    componentDidUpdate(prevProps, prevState){

        if(this.state.ecgData != null && !this.state.instanciated && this.props.id !== null){

            var element_id = this.props.id;
            var ecgData = this.state.ecgData;

            var drawGrid = this.props.drawGrid;
            var drawInnerGrid = this.props.drawInnerGrid;
            var drawMarks = this.props.drawMarks;
            var marks = this.props.marks;

            var ECGLineColor = this.props.ECGLineColor;
            var gridLineColor = this.props.gridLineColor;
            var gridInnerLineColor = this.props.gridInnerLineColor;
            var traceName = this.props.traceName;

            var totalTime = this.props.totalTime;
            var displayTime = this.props.displayTime;
            var startFrom = this.props.startFrom;

            var sampleRate = this.props.ecgSampleRate;
            var resolution = this.props.ecgResolution;

            var parentWidth = this.elementContainer.offsetWidth;
            var created = false;

            //Callbacks
            var onMeasurementChange = this.props.onMeasurementChange;

            var elementDOM = findDOMNode(this.refs[this.props.id]);

            //$(function(){
                if( ecgData == null || parentWidth <= 0){
                    return;
                }

                var totalTime = totalTime;
                var ecgDataPoints = [];

                // ZOOM
                var timeFactor = 25;
                var timeAmpliation = 25;
                var gainAmplification = 2;

                $(elementDOM).webECG({
                    "totalTime": displayTime,
                    "sampleRate": sampleRate,
                    "resolution": resolution,
                    "traceName": traceName,
                    "ecgData": ecgData,
                    "startFrom": startFrom,

                    "ECGLineSize": 1,
                    "ECGLineColor": ECGLineColor,
                    "gridLineColor": gridLineColor,
                    "gridInnerLineColor": gridInnerLineColor,

                    "drawGrid": drawGrid,
                    "drawInnerGrid": drawInnerGrid,
                    "drawMarks": drawMarks,
                    "marks": marks
                });

                if($(elementDOM).initCanvas){
                    $(elementDOM).initCanvas();
                    $(elementDOM).onMeasurementChange(onMeasurementChange);
                }


                $("#gain-zoom-up-"+element_id).click(function(){
                    $(elementDOM).setGainZoom($(elementDOM).getGainZoom() + 1);
                });
                $("#gain-zoom-down-"+element_id).click(function(){
                    $(elementDOM).setGainZoom($(elementDOM).getGainZoom() -1);
                });

                $("#time-zoom-up-"+element_id).click(function(){
                    $(elementDOM).setTimeZoom($(elementDOM).getTimeZoom() + 25);
                });
                $("#time-zoom-down-"+element_id).click(function(){
                    $(elementDOM).setTimeZoom($(elementDOM).getTimeZoom() - 25);
                });

                $('.ecg-wrapper, .ecg-dragscroll').dragscrollable({
                  dragSelector: 'canvas',
                  acceptPropagatedEvent: false,
                  preventDefault: false
                });

                created = true;
            //});

            if(created)
                this.setState({instanciated: true});
        }else{
          //Criação do plugin WEBECG rejeitada
          //console.log("REJECTED");
        }
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.ecgData !== this.state.ecgData || this.props.traceName != nextProps.traceName) {
            this.setState({
              ecgData: nextProps.ecgData,
              instanciated: false
            });
        }
    }

    componentWillUnmount() {
        var element_id = this.props.id;
        $(function(){
            if($("#"+element_id).unmount)
                $("#"+element_id).unmount();
        });
    }

    render() {

        return (
            <div className="ecg-container">
                <div className="ecg-container">
                    <div className="ecg-container" key={"container-"+this.props.id+"-"+this.props.traceName} id={"container-"+this.props.id} className="ecg-container"
                        ref={container => {this.elementContainer = container}}>
                        <canvas id={this.props.id} ref={this.props.id} tabIndex='1'></canvas>
                    </div>
                </div>



            </div>
        )
    }
}

export default Ecg;



// WEBPACK FOOTER //
// ./src/views/Ecg/Ecg.js